import { IPalette } from "./types";

export const palette: IPalette = {
  primary: {
    50: '#F2F5FF',
    100: '#E5EBFE',
    200: '#7897FF',
    300: '#063EF9',
    400: '#0431C7',
    500: '#032596',
    main: '#032596'
  },
  secondary: {
    50: '#F2FFFF',
    100: '#E5FFFF',
    200: '#99FFFF',
    300: '#00FFFF',
    400: '#00CCCC',
    500: '#006666',
    main: '#006666'
  },
  tertiary: {
    50: '#F2FFFF',
    100: '#FEF4D7',
    200: '#FDDD87',
    300: '#FAB805',
    400: '#F0B105',
    500: '#C89404',
    main: '#C89404'
  },
  green: {
    50: '#F2FFF9',
    100: '#E5FFF2',
    200: '#4CFFA6',
    300: '#00CC67',
    400: '#00994D',
    500: '#006633',
    main: '#006633'
  },
  orange: {
    50: '#FFF8F2',
    100: '#FFF1E5',
    200: '#FFE7CF',
    300: '#FF7500',
    400: '#CC5E00',
    500: '#662F00',
    main: '#662F00'
  },
  red: {
    50: '#FFF2F2',
    100: '#FFE5E5',
    200: '#FF9999',
    300: '#FF0000',
    400: '#CC0000',
    500: '#660000',
    main: '#660000'
  },
  yellow: {
    50: '#FEFEE5',
    100: '#F3F3B2',
    200: '#F2F294',
    300: '#EEEE2C',
    400: '#DCC80F',
    500: '#6A5300',
    main: '#6A5300',
  },
  grayscale: {
    50: '#FCFCFC',
    100: '#F7F7FC',
    200: '#EFF0F6',
    300: '#D9DBE9',
    400: '#A0A3BD',
    500: '#6E7191',
    600: '#4E4B66',
    700: '#262338',
    800: '#14142B',
  },
  purple: {
    50: '#E6D0FF',
    100: '#E6D0FF',
    200: '#E6D0FF',
    300: '#E6D0FF',
    400: '#42307D',
    500: '#42307D',
    main: '#42307D'
  },
  pink: {
    50: '#FFD8F4',
    100: '#FFD8F4',
    200: '#FFD8F4',
    300: '#FFD8F4',
    400: '#9E165F',
    500: '#9E165F',
    main: '#FFD8F4'
  },
  lightyellow: {
    50: '#FEF0C7',
    100: '#FEF0C7',
    200: '#FEF0C7',
    300: '#FEF0C7',
    400: '#93370D',
    500: '#93370D',
    main: '#FEF0C7'
  },
  transparent: {
    light: {
      95: '#EFF0F6F2',
      75: '#EFF0F6BF',
      65: '#EFF0F6A6',
      40: '#EFF0F666',
      25: '#EFF0F640',
      10: '#EFF0F61A'
    },
    dark: {
      95: '#14142BF2',
      75: '#14142BBF',
      65: '#14142BA6',
      40: '#14142B66',
      25: '#14142B40',
      10: '#14142B1A'
    }
  },
  white: '#FFFFFF',
  black: '#000000'
}
